<template>
  <el-card>
    <div class="h-full" v-if="currentComp === 'TABLE'">
      <div class="flex mb-20px mr-10px">
        <el-input
          size="small"
          class="mr-10px !w-50"
          placeholder="请输入卡片名称、编号"
          v-model="equipSearchData.keywords"
          clearable
        ></el-input>
        <el-select
          size="small"
          class="mr-10px !w-50"
          filterable
          placeholder="请选择区域"
          v-model="equipSearchData.occurredAreaId"
          clearable
        >
          <el-option
            v-for="item in areaList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-button size="small" type="primary" @click="handleSearch()">搜索</el-button>
        <el-button size="small" @click="resetText()">重置</el-button>
        <el-button
          size="small"
          type="primary"
          @click="handleEvent(null, 'create')"
          :disabled="!$hasAccess('create')"
          >新增</el-button
        >
        <el-button
          size="small"
          type="danger"
          @click="handleEvent(null, 'batchDelete')"
          :disabled="!$hasAccess('delete')"
          >批量删除</el-button
        >
      </div>
      <el-table
        :data="equipDataList"
        border
        class="w-full"
        :height="tableHeight"
        stripe
        v-loading="equipTableLoading"
        @selection-change="handleSelectionEquip"
      >
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column
          label="卡片名称"
          prop="cardName"
          width="180"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="卡片编号"
          prop="cardNum"
          width="180"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="发生区域"
          prop="occurredAreaStr"
          width="180"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="事故类型"
          prop="accidentTypeStr"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="可能导致的事故"
          prop="mayResultAccidentsStr"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="操作" width="300" fixed="right">
          <template slot-scope="scope">
            <table-operate-button :key="scope.row.id" :buttons="buttonsEquip(scope.row)" />
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="equipTableSizeChange"
        @current-change="equipTableCurrentChange"
        :current-page.sync="equipPageConfig.SkipCount"
        :page-size.sync="equipPageConfig.MaxResultCount"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[15, 30, 45, 60, 75, 90]"
        :total="equipTotalCount"
        class="float-right mt-20px ml-10px"
      ></el-pagination>
    </div>

    <deal-methods-form
      :FormData="FormData"
      v-if="currentComp === 'CREATE' || currentComp === 'UPDATE' || currentComp === 'READ'"
      @refreshList="
        checkComp('TABLE')
        getEquipList()
      "
      @cancel="checkComp('TABLE')"
      :formProps="formProps"
    ></deal-methods-form>

    <deal-methods-card
      v-if="currentComp === 'CARD'"
      :rowId="rowId"
      @cancel="checkComp('TABLE')"
    ></deal-methods-card>
  </el-card>
</template>

<script>
import TableOperateButton from '@/components/safety/TableOperateButton/TableOperateButton'
import { AreaApi } from '@wiz-api/area-management'
import { DisposalMethodEmergencyCardApi } from '@wiz-api/double-prevention-management'
import DownResultFile from '@/assets/js/safety/DownResultFile'
import DealMethodsForm from '../../components/ThreeCardForm/DealMethodsForm'
import DealMethodsCard from '../../components/ThreeCardForm/DealMethodsCard'

const areaApi = new AreaApi()
const disposalMethodEmergencyCardApi = new DisposalMethodEmergencyCardApi()

export default {
  name: 'deal-methods',
  mixins: [DownResultFile],
  components: {
    TableOperateButton,
    DealMethodsForm,
    DealMethodsCard,
  },
  data() {
    return {
      rowId: null,
      currentComp: 'TABLE',
      FormData: {
        cardName: '',
        cardNum: '',
        accidentType: null,
        occurredAreaId: undefined,
        occurrencePossibleTime: undefined,
        influenceScope: '',
        mayResultAccidents: undefined,
        specificLocations: '',
        appearanceSigns: '',
        derivativeAccidents: '',
        emergencyResponseTaskForceResponsibilities: '',
        emergencyProcedures: '',
        onSiteDisposalMeasures: '',
        policeCall: null,
        accidentReportContents: '',
        precautions: '',
      },
      formDialog: false,
      formProps: {
        // create 新增 update 编辑 read 详情
        pageType: 'create',
      },
      areaList: [],
      // 设备设施清单
      equipDataList: [],
      equipTableLoading: false,
      equipTotalCount: 0,
      equipSearchData: {
        keywords: '',
        occurredAreaId: undefined,
      },
      equipPageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
      },
      selectionEquipData: [],
    }
  },
  created() {
    this.getEquipList()
    // 获取区域列表
    this.getAreaList()
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 110px)'
    },
    buttonsEquip() {
      return (val) => {
        return [
          {
            text: '查看',
            click: () => {
              return this.handleEvent(val, 'read')
            },
            isShow: this.$hasAccess('read'),
          },
          {
            text: '编辑',
            click: () => {
              return this.handleEvent(val, 'update')
            },
            isShow: this.$hasAccess('update'),
          },
          {
            text: '删除',
            click: () => {
              return this.handleEvent(val, 'delete')
            },
            isShow: this.$hasAccess('delete'),
          },
          {
            text: '应知卡',
            click: () => {
              return this.handleEvent(val, 'card')
            },
            isShow: this.$hasAccess('card'),
          },
        ]
      }
    },
  },
  methods: {
    // 切换组件
    checkComp(name) {
      this.currentComp = null
      this.$nextTick(() => {
        this.currentComp = name
      })
    },
    // 重置
    resetText() {
      this.equipSearchData = this.$options.data().equipSearchData
      this.handleSearch()
    },
    // 获取区域列表
    async getAreaList() {
      const [err, res] = await areaApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.areaList = res.items || []
      }
    },
    // 列表操作-事件 设备设施清单
    async handleEvent(row = null, operation) {
      let err = null
      let res = null
      switch (operation) {
        case 'create':
          this.FormData = this.$options.data().FormData
          this.initDialog(operation)
          break
        case 'delete':
          this.$confirm('是否删除该记录？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              ;[err, res] = await disposalMethodEmergencyCardApi.callDelete(row.id)
              if (!err) {
                this.$message({
                  showClose: true,
                  message: '删除成功',
                  type: 'success',
                })
                this.getEquipList()
              }
            })
            .catch(() => {})
          break
        case 'read':
          this.FormData = this.$options.data().FormData
          ;[err, res] = await disposalMethodEmergencyCardApi.get(row.id)
          if (!err) {
            this.FormData = {
              ...this.FormData,
              ...res,
            }
            this.initDialog(operation)
          }
          break
        case 'batchExport':
          ;[err, res] = await disposalMethodEmergencyCardApi.exportToExcelFile()
          if (!err) {
            this.downLoadExcel('风险分析单元数据', res)
            this.$message({
              showClose: true,
              message: '导出成功',
              type: 'success',
            })
          }
          break
        case 'update':
          this.FormData = this.$options.data().FormData
          ;[err, res] = await disposalMethodEmergencyCardApi.get(row.id)
          if (!err) {
            this.FormData = {
              ...this.FormData,
              ...res,
            }
            this.initDialog(operation)
          }
          break
        // 批量删除
        case 'batchDelete':
          if (this.selectionEquipData.length === 0) {
            this.$message({
              showClose: true,
              message: '请勾选要删除的记录',
              type: 'warning',
            })
            return
          }
          this.$confirm('是否批量删除勾选的记录', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              ;[err, res] = await disposalMethodEmergencyCardApi.deleteMany({
                ids: this.selectionEquipData,
              })
              if (!err) {
                this.$message({
                  showClose: true,
                  message: '删除成功',
                  type: 'success',
                })
                this.getEquipList()
              }
            })
            .catch(() => {})
          break
        case 'card':
          this.rowId = row.id
          this.checkComp('CARD')
          break
        default:
          break
      }
    },
    // 弹窗初始化操作
    initDialog(operation) {
      this.checkComp(operation.toUpperCase())
      this.formProps.pageType = operation
    },
    handleSelectionEquip(values) {
      this.selectionEquipData = values.map((item) => {
        return item.id
      })
    },
    // 搜索
    handleSearch() {
      this.equipPageConfig.SkipCount = 1
      this.getEquipList()
    },
    // 页码改变
    equipTableSizeChange(MaxResultCount) {
      this.equipPageConfig.MaxResultCount = MaxResultCount
      this.getEquipList()
    },
    // 页数改变
    equipTableCurrentChange(SkipCount) {
      this.equipPageConfig.SkipCount = SkipCount
      this.getEquipList()
    },
    // 设备设施列表
    async getEquipList() {
      this.selectionEquipData = []
      const data = {
        maxResultCount: this.equipPageConfig.MaxResultCount, // 每页多少条
        skipCount: (this.equipPageConfig.SkipCount - 1) * this.equipPageConfig.MaxResultCount, // 跳过多少条
        ...this.equipSearchData,
      }
      this.equipTableLoading = true
      const [err, res] = await disposalMethodEmergencyCardApi.pagedListQuery(data)
      if (!err) {
        this.equipDataList = res.items
        this.equipTotalCount = res.totalCount
      }
      this.equipTableLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
  height: 100%;
}
</style>
